<div class="not-found-container">
  <h3 class="header-404">4<span>O</span>4</h3>
  <div class="description-container">
    <strong>OOPS, PAGE NOT FOUND</strong>
    We couldn't find the page you are looking for
  </div>
  <a class="back-button" href="/">BACK TO HOME</a>
</div>
